import {
  Button,
  Div,
  H3,
  Icon,
  Img,
  P,
  PlusIcon,
  SuccessToast,
  deleteBrandTemplateMenuTypeItemById,
  noModifierGroups,
  reportError,
} from '@vgrubs/components';
import { ItemType } from 'components/src/types/menu.types';
import { Dispatch, SetStateAction, useState } from 'react';
import { useParams } from 'react-router';
import { AddNewModifierGroupModal } from './AddNewModifierGroupModal';
import { DeleteModifierModal } from './DeleteModifierModal';
import { ModifierGroupComponent } from './ModifierComponents';
import {
  BTMenuResponse,
  BTModifierGroupItemResponse,
} from 'components/src/types/brand.types';

const removeModifierGroupById = (data: BTMenuResponse, idToRemove: number) => {
  return {
    ...data,
    modifierGroups: data.modifierGroups.filter((c) => c.id !== idToRemove),
  };
};

export const Modifiers = ({
  menu,
  setMenu,
  setLoading,
}: {
  menu: BTMenuResponse | null;
  setMenu: Dispatch<SetStateAction<BTMenuResponse | null>>;
  setLoading: Dispatch<SetStateAction<boolean>>;
}) => {
  const [addNewModal, setAddNewModal] = useState(false);
  const [editModal, setEditModal] =
    useState<BTModifierGroupItemResponse | null>(null);
  const [deleteModal, setDeleteModal] = useState<number | null>(null);

  const { brandTemplateId } = useParams() as {
    brandTemplateId: string;
  };

  async function handleDeleteItem() {
    if (!deleteModal) return;
    try {
      setLoading(true);
      const { data } = await deleteBrandTemplateMenuTypeItemById(
        brandTemplateId,
        deleteModal,
        ItemType.ModifierGroup
      );

      setMenu((prev) =>
        !prev ? prev : removeModifierGroupById(prev, deleteModal)
      );
      SuccessToast(data.message);
      setDeleteModal(null);
    } catch (error) {
      reportError(error);
    } finally {
      setLoading(false);
    }
  }

  const AddModifierGroupButton = () => {
    return (
      <Button $selected onClick={() => setAddNewModal(true)}>
        Add Modifier Group
      </Button>
    );
  };

  return (
    <Div>
      <Div $flex $between $alignCenter $mb="20">
        <H3 $mb="0">
          {menu?.modifierGroups && menu?.modifierGroups?.length < 1
            ? 'Modifier Group'
            : 'Modifier Groups'}{' '}
          ({menu?.modifierGroups?.length})
        </H3>

        {menu?.modifierGroups && menu?.modifierGroups?.length > 0 && (
          <Icon $pointer onClick={() => setAddNewModal(true)}>
            <PlusIcon />
          </Icon>
        )}
      </Div>

      {menu?.modifierGroups?.map((item, i) => (
        <ModifierGroupComponent
          key={i}
          item={item}
          onClickDelete={(id) => setDeleteModal(id)}
          onClick={(item) => setEditModal(item)}
        />
      ))}

      {menu?.modifierGroups && menu?.modifierGroups?.length < 1 && (
        <Div $flex $column $alignCenter>
          <Img alt="" $width="180px" src={noModifierGroups} $mb="24" />
          <H3 $mb="24" $center>
            No Modifier Groups
          </H3>
          <P $mb="32" $center>
            This provider currently don’t have <br /> menu modifier groups.
          </P>
          <AddModifierGroupButton />
        </Div>
      )}

      <AddNewModifierGroupModal
        addNewModal={addNewModal}
        closeModal={() => {
          setAddNewModal(false);
        }}
        setMenu={setMenu}
        setLoading={setLoading}
      />

      <AddNewModifierGroupModal
        addNewModal={editModal}
        closeModal={() => {
          setEditModal(null);
        }}
        setMenu={setMenu}
        setLoading={setLoading}
        edit
      />

      <DeleteModifierModal
        deleteModal={!!deleteModal}
        closeModal={() => {
          setDeleteModal(null);
        }}
        handleDeleteItem={handleDeleteItem}
      />
    </Div>
  );
};
